var map = {
	"./frontend/AndroidGuide.vue": 3110,
	"./frontend/Banking.vue": 2196,
	"./frontend/BetslipHistory.vue": 2795,
	"./frontend/BodyFB.vue": 8294,
	"./frontend/Commission.vue": 8677,
	"./frontend/ContactUs.vue": 477,
	"./frontend/DataTable.vue": 818,
	"./frontend/Deposit.vue": 4401,
	"./frontend/History.vue": 6267,
	"./frontend/Home.vue": 9266,
	"./frontend/IOSGuide.vue": 9210,
	"./frontend/Iframe copy.vue": 3020,
	"./frontend/Iframe.vue": 5880,
	"./frontend/Index.vue": 621,
	"./frontend/Live.vue": 6804,
	"./frontend/LiveScore.vue": 5634,
	"./frontend/MainMenu.vue": 4694,
	"./frontend/MaungFB.vue": 9953,
	"./frontend/Promotion.vue": 4851,
	"./frontend/Setting.vue": 6601,
	"./frontend/VideoLink.vue": 1601,
	"./frontend/VipLevels.vue": 1954,
	"./frontend/Withdraw.vue": 4954,
	"./frontend/auth/Login.vue": 9142,
	"./frontend/auth/Register.vue": 4221,
	"./frontend/auth/Rule.vue": 2251,
	"./frontend/auth/Verify.vue": 1581,
	"./frontend/auth/VerifyNotAuth.vue": 2739,
	"./frontend/components/AccountSelect.vue": 6311,
	"./frontend/components/DataTable.vue": 9393,
	"./frontend/components/FBPreviewVoucher.vue": 113,
	"./frontend/components/FBVoucher.vue": 4528,
	"./frontend/components/FootballTeamCard.vue": 5742,
	"./frontend/components/GroupBox.vue": 3593,
	"./frontend/components/InputSelectDrawModal.vue": 7621,
	"./frontend/components/LuckyWheel.vue": 4223,
	"./frontend/components/NormalBox.vue": 6251,
	"./frontend/components/PreviewVoucher.vue": 8096,
	"./frontend/components/SideNav.vue": 1604,
	"./frontend/components/Table.vue": 326,
	"./frontend/components/ThreedGroupBox.vue": 5327,
	"./frontend/components/TwoDSelect.vue": 8796,
	"./frontend/components/Voucher.vue": 7607,
	"./frontend/normal-user/2d/2d.vue": 922,
	"./frontend/normal-user/2d/ClosedDays.vue": 2083,
	"./frontend/normal-user/2d/Home.vue": 3034,
	"./frontend/normal-user/2d/Winner.vue": 24,
	"./frontend/normal-user/3d/3d.vue": 6938,
	"./frontend/normal-user/3d/Home.vue": 9750,
	"./frontend/normal-user/DreamBooks.vue": 5641,
	"./frontend/normal-user/Index.vue": 5531,
	"./frontend/normal-user/bugyee/Room.vue": 9666,
	"./frontend/normal-user/game/Arcade.vue": 4921,
	"./frontend/normal-user/game/Fishing.vue": 4231,
	"./frontend/normal-user/game/Game.vue": 9621,
	"./frontend/normal-user/game/Slot.vue": 302,
	"./frontend/normal-user/shankomee/Room.vue": 4199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7057;